<script setup lang="ts">
import { createSidebar, provideSidebar } from './useSidebar'

const sidebar = createSidebar()
provideSidebar(sidebar)
</script>

<template>
  <div class="group/sidebar-wrapper flex h-screen w-full overflow-y-auto relative">
    <slot />
  </div>
</template>
